import request from '@/config/axios'

// 文件预签名地址 Response VO
export interface FilePresignedUrlRespVO {
  // 文件配置编号
  configId: number
  // 文件上传 URL
  uploadUrl: string
  // 文件 URL
  url: string
  // 文件路径
  path: string
}

/** 文件 / 素材库列表项（infra_file） */
export interface FileVO {
  id: number
  configId?: number
  tenantId?: number
  bizModule?: string
  libraryScope?: string
  ownerUserId?: number
  /** 会员已从「我的素材」移除，仍占配额 */
  memberRemoved?: boolean
  path?: string
  name?: string
  url: string
  type?: string
  size?: number
  createTime?: string
}

export interface FileMaterialGroupsVO {
  legacyDirs: string[]
}

export interface FilePageQuery {
  pageNo: number
  pageSize: number
  path?: string
  name?: string
  type?: string
  bizModule?: string
  libraryScope?: string
  memberRemoved?: boolean
  legacyDir?: string
  mediaCategory?: 'IMAGE' | 'VIDEO' | 'FILE' | ''
  createTime?: string[]
}

// 查询文件列表（运维：需 infra:file:query）
export const getFilePage = (params: FilePageQuery | any) => {
  return request.get({ url: '/infra/file/page', params })
}

/** 素材库分页（登录即可，本租户） */
export const getMaterialPage = (params: FilePageQuery) => {
  return request.get({ url: '/infra/file/material-page', params })
}

/** 素材库历史目录分组 */
export const getMaterialGroups = (): Promise<FileMaterialGroupsVO> => {
  return request.get({ url: '/infra/file/material-groups' })
}

// 删除文件
export const deleteFile = (id: number) => {
  return request.delete({ url: '/infra/file/delete?id=' + id })
}

// 批量删除文件
export const deleteFileList = (ids: number[]) => {
  return request.delete({ url: '/infra/file/delete-list', params: { ids: ids.join(',') } })
}

// 上传文件 Response VO（/infra/file/upload-detail 返回）
export interface FileUploadRespVO {
  // 文件编号（infra_file.id），业务表应存为 file_id 外键
  id: string
  // 原文件名
  name: string
  // 文件访问地址
  url: string
  // 文件大小（字节）
  size: number
  // 文件 MIME 类型
  type: string
  // 业务模块码
  bizModule?: string
}

// 获取文件预签名地址
// size 用于 OSS 配额的前置校验：预签名直传绕过后端，不在发地址前拦截就会先占用 OSS 再被拒
export const getFilePresignedUrl = (name: string, directory?: string, size?: number) => {
  return request.get<FilePresignedUrlRespVO>({
    url: '/infra/file/presigned-url',
    params: { name, directory, size }
  })
}

// 创建文件
export const createFile = (data: any) => {
  return request.post({ url: '/infra/file/create', data })
}

// 上传文件
export const updateFile = (data: any, onUploadProgress?: Function) => {
  return request.upload({ url: '/infra/file/upload', data, onUploadProgress })
}

// 上传文件（返回 file_id 等完整信息），供需要落 file_id 外键的业务媒体表使用
export const uploadFileDetail = (data: any, onUploadProgress?: Function) => {
  return request.upload({ url: '/infra/file/upload-detail', data, onUploadProgress })
}
